import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    verificationPendingTitle: {
        id: 'migration.modal.verification_pending.title',
        defaultMessage: 'We are verifying your identity',
    },
    verificationPendingSubtitle: {
        id: 'migration.modal.verification_pending.subtitle',
        defaultMessage: 'It can take some time. Please come back later',
    },
    signOutButtonText: {
        id: 'migration.modal.verification_pending_sign_out_button.text',
        defaultMessage: 'Sign out',
    },
})
